import { Route, Routes } from "react-router-dom";
import GroupTable from "./Group/GroupTable";
import LedgerTable from "./Ledger/LedgerTable";
import { SearchLedgerByGroupsTypes } from "../../Services/LedgerService";
import ResourceNotFound from "../../Common/ResourceNotFound";
import { findUserOnlyOnePremission } from "../Users/UserSecurityFind";
import { useUser } from "../../../Context/UserContext";
import { useClient } from "../../Context/ClientContext";

const PartyNestedRoute = () => {
  const { clientSpecificRole } = useUser();
  const { currentClient } = useClient();

  return (
    <Routes>
      <Route
        path="/parties"
        element={
          findUserOnlyOnePremission(
            "Master.Ledger.Party.View",
            clientSpecificRole(),
            currentClient?.id!
          ) ? (
            <LedgerTable
              showName="Party"
              ledgerByGroupsType={SearchLedgerByGroupsTypes.PartiesOnly}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path="/partiesGroup"
        element={
          findUserOnlyOnePremission(
            "Master.Group.Party.View",
            clientSpecificRole(),
            currentClient?.id!
          ) ? (
            <GroupTable
              showName="Party's Group"
              searchLedgerByGroupsTypes={SearchLedgerByGroupsTypes.PartiesOnly}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
    </Routes>
  );
};

export default PartyNestedRoute;
